import { render, staticRenderFns } from "./notificationTrigger.vue?vue&type=template&id=a4a28cbe&scoped=true"
import script from "./notificationTrigger.vue?vue&type=script&lang=js"
export * from "./notificationTrigger.vue?vue&type=script&lang=js"
import style0 from "./notificationTrigger.vue?vue&type=style&index=0&id=a4a28cbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a28cbe",
  null
  
)

export default component.exports